import { createFileRoute } from '@tanstack/react-router';
import { AppEditorSkeleton } from 'src/shared/components/skeletons/AppEditorSkeleton';

export const Route = createFileRoute('/_authenticated/apps/$appId')({
  head: () => ({
    meta: [{ title: 'Code editor | Tekst' }],
  }),
  pendingComponent: AppEditorSkeleton,
});
